/**
 * Creates a valid `mailto:` link.
 *
 * Handles how to do a custom encoding that works for modern web email clients as well as
 * older application clients which don't support converting `+` to a space.
 *
 * @example
 * <a href={createMailToLink('this@flowcode.com')} />
 *   This Link
 * </a>
 * <Link href={createMailToLink('that@flowcode.com', { subject: 'hi', body: 'hello there' })}>
 *   <a>That Link</a>
 * </Link>
 */
export function createMailToLink(
  email: string,
  fields: { body?: string; subject?: string } = {}
): string {
  const base = `mailto:${email}`
  const params = []
  if (fields.subject) params.push(`subject=${encodeURIComponent(fields.subject)}`)
  if (fields.body) params.push(`body=${encodeURIComponent(fields.body)}`)
  if (!params.length) return base
  return `${base}?${params.join('&')}`
}
